<template>
  <v-card>
    <v-card-title
      class="pr-2"
      :style="{ backgroundColor: companyPrimaryColor }"
    >
      <h2 style="color:white">Gebruiker bewerken</h2>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeEditUserDialog()">
        <v-icon dark color="white">close</v-icon>
      </v-btn>
    </v-card-title>

    <v-alert class="ma-2 pa-2" v-if="feedback" :value="true" type="warning">
      {{ feedback }}
    </v-alert>

    <v-divider></v-divider>

    <v-card-text>
      <v-form ref="EditUserForm" lazy-validation>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex xs12 v-if="formType == 'superadmin'">
              <v-select
                class="pt-2"
                :items="companies"
                v-model="userFormInfo.company"
                label="Bedrijf"
                hint="Selecteer bij welk bedrijf de gebruiker hoort"
                item-text="name"
                item-value="id"
                prepend-inner-icon="business"
                persistent-hint
                v-on:input="loadBranches(userFormInfo.company)"
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
              ></v-select>
            </v-flex>

            <v-flex md6 xs12>
              <v-text-field
                class="pt-2"
                label="Voornaam"
                v-model="userFormInfo.firstName"
                autocomplete="disabled"
                prepend-inner-icon="account_box"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex md6 xs12>
              <v-text-field
                class="pt-2"
                label="Achternaam"
                v-model="userFormInfo.lastName"
                autocomplete="disabled"
                prepend-inner-icon="account_box"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                class="pt-2"
                label="E-mailadres"
                v-model="userFormInfo.email"
                :rules="emailRules"
                autocomplete="disabled"
                prepend-inner-icon="email"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                class="pt-2"
                :items="userRoles"
                v-model="userFormInfo.userRole"
                label="Rol"
                item-text="name"
                item-value="id"
                prepend-inner-icon="verified_user"
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-select>
              <div
                v-if="userFormInfo.userRole == 'admin'"
                class="userrole-explaination"
              >
                Een
                <b>Admin</b> heeft alle bevoegdheden.
              </div>
              <div
                v-if="userFormInfo.userRole == 'manager'"
                class="userrole-explaination"
              >
                Een
                <b>Managers</b> heeft de bevoegdheid om gegevens van medewerkers
                te wijzigen en nieuwe gebruikers aan te maken. Extra
                gebruikerrechten kunnen per gebruiker worden toegevoegd.
              </div>
              <div
                v-if="userFormInfo.userRole == 'employee'"
                class="userrole-explaination"
              >
                Een
                <b>Medewerker</b> heeft standaard alleen de bevoegdheid om
                beperkte gegevens te bekijken. Extra gebruikerrechten kunnen per
                gebruiker worden toegevoegd.
              </div>
            </v-flex>

            <v-flex
              xs12
              v-if="
                userFormInfo.userRole == 'employee' ||
                  userFormInfo.userRole == 'manager'
              "
            >
              <v-select
                class="pt-2"
                v-if="formType == 'superadmin'"
                :items="loadedBranches"
                v-model="userFormInfo.branches"
                label="Vestigingen"
                item-text="branchName"
                hint="Selecteer tot welke branches de gebruiker toegang heeft"
                item-value="id"
                multiple
                prepend-inner-icon="business"
                persistent-hint
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-select>
              <v-select
                class="pt-2"
                v-if="formType == 'company'"
                :items="branches"
                v-model="userFormInfo.branches"
                label="Vestigingen"
                item-text="branchName"
                hint="Selecteer tot welke branches de gebruiker toegang heeft"
                item-value="id"
                multiple
                prepend-inner-icon="business"
                persistent-hint
                :color="companyPrimaryColor"
                :item-color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
              ></v-select>
            </v-flex>
            <v-flex xs12 v-if="formType == 'superadmin'">
              <v-switch
                :color="companyPrimaryColor"
                v-model="userFormInfo.callActive"
                label="Call Center actief voor gebruiker"
                class="pa-0"
                hide-details
              >
              </v-switch>
            </v-flex>

            <v-flex
              xs12
              v-if="formType == 'superadmin' && userFormInfo.callActive"
            >
              <v-switch
                :color="companyPrimaryColor"
                v-model="userFormInfo.hogansCaller"
                label="Belt voor Hogans Call Center"
                class="pa-0"
                hide-details
                v-on:change="setCallToType()"
              >
              </v-switch>
            </v-flex>

            <v-flex
              xs12
              v-if="formType == 'superadmin' && userFormInfo.callActive"
            >
              <v-select
                class="mt-4"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                background-color="background"
                item-text="name"
                item-value="id"
                multiple
                chips
                prepend-inner-icon="check"
                v-model="userFormInfo.callCompanies"
                no-data-text="Geen bedrijven gevonden."
                label="Selecteer bedrijven voor Call Center"
                :hint="
                  `${userFormInfo.callCompanies.length}/${companies.length} bedrijven geselecteerd.`
                "
                persistent-hint
                outlined
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content class="pt-0">
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        clearable
                        v-model="searchCompanies"
                        hide-details
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div
                    v-if="searchCompanies && searchCompanies.length > 0"
                    style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px"
                  >
                    {{ filteredCompanies.length }} van
                    {{ companies.length }} bedrijven
                  </div>
                  <v-divider v-if="searchCompanies.length > 0"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip small color="primary" dark v-if="index === 0"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 1"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 2"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 3"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 4"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 5"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <span v-if="index === 6" class="grey--text caption"
                    >(+{{ userFormInfo.callCompanies.length - 6 }} andere)</span
                  >
                </template>
              </v-select>
            </v-flex>

            <v-flex
              xs12
              v-if="
                formType == 'superadmin' &&
                  userFormInfo.callActive &&
                  !userFormInfo.hogansCaller
              "
            >
              <v-text-field
                class="mt-2"
                label="Telefoonnummer Call Center"
                v-model="userFormInfo.callTo"
                autocomplete="disabled"
                :color="companyPrimaryColor"
                background-color="background"
                hide-details
                outlined
                required
                prepend-inner-icon="phone"
              ></v-text-field>
            </v-flex>

            <v-flex
              xs12
              v-if="
                formType == 'superadmin' &&
                  userFormInfo.callActive &&
                  userFormInfo.hogansCaller &&
                  userFormInfo.callCompanies.length > 0
              "
            >
              <v-card
                outlined
                :color="$vuetify.theme.themes[theme].menuhover"
                class="pa-4"
              >
                <h3>Telefoonnummers voor Call Center</h3>
                <div v-if="userFormInfo.callCompanies.length > 0">
                  <div
                    v-for="(company, index) in userFormInfo.callCompanies"
                    :key="index"
                  >
                    <v-text-field
                      class="mt-4"
                      :label="`Telefoonnummer voor ${company}`"
                      v-model="userFormInfo.callTo[company]"
                      autocomplete="disabled"
                      :color="companyPrimaryColor"
                      background-color="background"
                      hide-details
                      outlined
                      required
                      prepend-inner-icon="phone"
                    ></v-text-field>
                  </div>
                </div>
                <div class="pt-1" v-else>
                  <i>Selecteer bedrijven voor Call Center</i>
                </div>
              </v-card>
            </v-flex>

            <v-flex
              xs12
              v-if="
                formType == 'superadmin' &&
                  userFormInfo.userRole == 'superadmin'
              "
            >
              <v-select
                class="mt-4"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                background-color="background"
                item-text="name"
                item-value="id"
                multiple
                chips
                prepend-inner-icon="check"
                v-model="userFormInfo.accessCompanies"
                no-data-text="Geen bedrijven gevonden."
                label="Selecteer toegang tot bedrijven"
                :hint="
                  `${userFormInfo.accessCompanies.length}/${companies.length} bedrijven geselecteerd.`
                "
                persistent-hint
                outlined
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content class="pt-0">
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        clearable
                        v-model="searchCompanies"
                        hide-details
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div
                    v-if="searchCompanies && searchCompanies.length > 0"
                    style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px"
                  >
                    {{ filteredCompanies.length }} van
                    {{ companies.length }} bedrijven
                  </div>
                  <v-divider v-if="searchCompanies.length > 0"></v-divider>
                </template>
                <template v-slot:selection="{ item, index }">
                  <v-chip small color="primary" dark v-if="index === 0"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 1"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 2"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 3"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 4"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <v-chip small color="primary" dark v-if="index === 5"
                    ><span style="color:white">{{ item.name }}</span></v-chip
                  >
                  <span v-if="index === 6" class="grey--text caption"
                    >(+{{
                      userFormInfo.accessCompanies.length - 6
                    }}
                    andere)</span
                  >
                </template>
              </v-select>
            </v-flex>
            <v-flex
              xs12
              class="user-permissions-wrapper clear"
              v-if="
                (userFormInfo.userRole == 'employee' &&
                  (userRole == 'admin' || userRole == 'superadmin')) ||
                  (userFormInfo.userRole == 'manager' &&
                    (userRole == 'admin' || userRole == 'superadmin'))
              "
            >
              <div
                v-if="companyJourney || companyNarrowcasting || companyDossier"
                style="padding: 10px 0"
                class="clear"
              >
                <div class="user-permissions-icon">
                  <v-icon>accessibility</v-icon>
                </div>
                <h3 style="padding: 7px 0 0 5px;">
                  Selecteer extra gebruikersrechten
                </h3>
              </div>
              <div class="user-permissions">
                <!-- Gebruikersrechten Customer Journey-->
                <div
                  v-if="companyJourney == true"
                  class="permissions-customerjourney"
                >
                  <h4>Reviews</h4>
                  <v-checkbox
                    label="Reviews bekijken"
                    v-model="userFormInfo.userPermissions.showJourneyData"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="userFormInfo.userPermissions.showJourneyData"
                    label="Vragenlijsten en vragen bekijken"
                    v-model="userFormInfo.userPermissions.journeyViewJourney"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="userFormInfo.userPermissions.showJourneyData"
                    label="Stages en vragen maken/bewerken"
                    v-model="userFormInfo.userPermissions.journeyEditQuestions"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    v-if="userFormInfo.userPermissions.showJourneyData"
                    label="Vragenlijsten maken/bewerken"
                    v-model="userFormInfo.userPermissions.journeyEditJourney"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                </div>
                <!-- Gebruikersrechten Relevantcasting-->
                <div
                  v-if="companyNarrowcasting == true"
                  class="permissions-relevantcasting"
                >
                  <h4>Relevantcasting</h4>
                  <v-checkbox
                    label="Content uploaden"
                    v-model="userFormInfo.userPermissions.castingUploadContent"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    label="Afspeellijst bewerken"
                    v-model="userFormInfo.userPermissions.castingEditPlaylist"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                </div>

                <!-- Gebruikersrechten Dossier -->
                <div
                  v-if="companyDossier == true"
                  class="permissions-relevantcasting"
                >
                  <h4>Dossier</h4>
                  <v-checkbox
                    label="Klantreviews verbergen in dossier"
                    v-model="userFormInfo.userPermissions.hideCustomerReviews"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                  <v-checkbox
                    label="Extra klantinformatie verbergen in dossier"
                    v-model="userFormInfo.userPermissions.hideCustomerInfo"
                    :color="companyPrimaryColor"
                  ></v-checkbox>
                </div>
              </div>
            </v-flex>
            <v-flex>
              <v-switch
                :color="companyPrimaryColor"
                v-model="userFormInfo.active"
                class="pa-0"
                hide-details
              >
                <template slot="label">
                  <span
                    :style="{ color: $vuetify.theme.themes[theme].text }"
                    style="margin-right: 5px;"
                    >Actief</span
                  >
                  <v-tooltip class="ma-0 pa-0" right>
                    <template v-slot:activator="{ on }">
                      <v-icon small :color="companyPrimaryColor" v-on="on"
                        >help</v-icon
                      >
                    </template>
                    <span class="white--text"
                      >Gebruiker kan alleen inloggen als het account actief
                      is.</span
                    >
                  </v-tooltip>
                </template>
              </v-switch>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-container grid-list-md fluid class="ma-0 pa-0">
        <v-layout row wrap class="ma-0 pa-0">
          <v-flex
            xs12
            md6
            class="text-left"
            v-if="
              $vuetify.breakpoint.name != 'sm' &&
                $vuetify.breakpoint.name != 'xs'
            "
          >
            <v-btn
              outlined
              depressed
              color="#8B93A6"
              @click="closeEditUserDialog()"
            >
              Annuleren
            </v-btn>
          </v-flex>
          <v-flex xs12 md6 class="text-right">
            <v-btn
              :disabled="!changed || busy"
              :depressed="!changed || busy"
              :dark="changed || busy"
              :block="
                $vuetify.breakpoint.name == 'sm' ||
                  $vuetify.breakpoint.name == 'xs'
              "
              rounded
              :color="companySecondaryColor"
              @click="updateUser()"
            >
              Wijzigingen opslaan
              <v-icon right dark>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
import slugify from "slugify";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import axios from "axios";
import platform from "platform";
import { bus } from "../../main";
import _ from "lodash";

export default {
  name: "edit-user-form",
  props: {
    formType: String,
    showDialog: Boolean,
    companies: Array,
    branches: Array,
    activeCompData: Object,
    userFormInfo: Object,
    userFormInfoOriginal: Object,
  },
  data() {
    return {
      busy: false,
      showEditDialog: true,
      feedback: null,
      errors: [],
      searchCompanies: "",
      loadedBranches: [],
      emailRules: [
        (v) => !!v || "E-mail is verplicht",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
      passwordRules: [(v) => !!v || "Wachtwoord is verplicht"],
    };
  },

  created() {
    bus.$on("getCompanyBranches", (company) => {
      this.loadBranches(company);
    });
  },

  methods: {
    setCallToType() {
      if (this.userFormInfo.hogansCaller) {
        this.userFormInfo.callTo = {};
      } else {
        if (typeof this.userFormInfoOriginal.callTo === "string") {
          this.userFormInfo.callTo = _.cloneDeep(
            this.userFormInfoOriginal.callTo,
          );
        } else {
          this.userFormInfo.callTo = "";
        }
      }
    },

    resetForm() {
      this.$refs.AddUserForm.reset();
    },

    closeEditUserDialog() {
      this.$emit("userEditDialogChange", false);
    },

    loadBranches(company) {
      if (company) {
        db.collection("branches")
          .where("compId", "==", company)
          .get()
          .then((snap) => {
            this.loadedBranches = [];
            snap.forEach((doc) => {
              let branchCollection = doc.data();
              branchCollection.id = doc.id;
              this.loadedBranches.push(branchCollection);
            });
          });
      }
    },

    updateUser() {
      this.busy = true;
      db.collection("users")
        .doc(this.userFormInfo.id)
        .update({
          firstName: this.userFormInfo.firstName,
          lastName: this.userFormInfo.lastName,
          userRole: this.userFormInfo.userRole,
          company: this.userFormInfo.company,
          branches: this.userFormInfo.branches,
          userPermissions: this.userFormInfo.userPermissions,
          accessCompanies: this.userFormInfo.accessCompanies,
          callActive: this.userFormInfo.callActive,
          callCompanies: this.userFormInfo.callCompanies,
          hogansCaller: this.userFormInfo.hogansCaller,
          callTo: this.userFormInfo.callTo,
          active: this.userFormInfo.active,
        })
        .then(() => {
          // Log Action
          db.collection("log").add({
            time: new Date(),
            logType: "info",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + " " + platform.version,
            pillarrrVersion: this.$store.state.version,
            action: "Gebruiker bewerkt",
            extra:
              "<b>ORIGINELE GEGEVENS</b>" +
              "<br>" +
              "<b>Naam</b>: " +
              this.userFormInfoOriginal.firstName +
              " " +
              this.userFormInfoOriginal.lastName +
              "<br>" +
              "<b>Rol</b>: " +
              this.userFormInfoOriginal.userRole +
              "<br>" +
              "<b>Email</b>: " +
              this.userFormInfoOriginal.email +
              "<br>" +
              "<b>Bedrijf</b>: " +
              this.userFormInfoOriginal.company +
              "<br>" +
              "<b>Toegang</b>: " +
              this.userFormInfoOriginal.accessCompanies +
              "<br>" +
              "<b>Beschikbaar voor bellen</b>: " +
              this.userFormInfoOriginal.callActive +
              "<br>" +
              "<b>Callcenter toegang</b>: " +
              this.userFormInfoOriginal.callCompanies +
              "<br>" +
              "<b>Belt voor Hogans</b>: " +
              this.userFormInfoOriginal.hogansCaller +
              "<br>" +
              "<b>Telefoonnummer Call Center</b>: " +
              this.userFormInfoOriginal.callTo +
              "<br><br>" +
              "<b>AANGEPASTE GEGEVENS</b>" +
              "<br>" +
              "<b>Naam</b>: " +
              this.userFormInfo.firstName +
              " " +
              this.userFormInfo.lastName +
              "<br>" +
              "<b>Rol</b>: " +
              this.userFormInfo.userRole +
              "<br>" +
              "<b>Email</b>: " +
              this.userFormInfo.email +
              "<br>" +
              "<b>Bedrijf</b>: " +
              this.userFormInfo.company +
              "<br>" +
              "<b>Toegang</b>: " +
              this.userFormInfo.accessCompanies +
              "<br>" +
              "<b>Beschikbaar voor bellen</b>: " +
              this.userFormInfo.callActive +
              "<br>" +
              "<b>Callcenter toegang</b>: " +
              this.userFormInfo.callCompanies +
              "<br>" +
              "<b>Belt voor Hogans</b>: " +
              this.userFormInfo.hogansCaller +
              "<br>" +
              "<b>Telefoonnummer Call Center</b>: " +
              this.userFormInfo.callTo,
          });
        })
        .then(() => {
          if (this.userFormInfoOriginal.active && !this.userFormInfo.active) {
            var config = {
              method: "post",
              url:
                "https://europe-west1-dev-app-137723.cloudfunctions.net/auth",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              data: {
                type: "disableUser",
                uid: this.userFormInfo.user_id,
              },
            };
            axios(config);
          }
          if (!this.userFormInfoOriginal.active && this.userFormInfo.active) {
            var config = {
              method: "post",
              url:
                "https://europe-west1-dev-app-137723.cloudfunctions.net/auth",
              headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*",
              },
              data: {
                type: "enableUser",
                uid: this.userFormInfo.user_id,
              },
            };
            axios(config);
          }

          this.$emit("updateData");
          this.closeEditUserDialog();
          this.busy = false;
          this.$refs.EditUserForm.reset();
        })
        .catch((error) => {
          console.error("Error updating User: ", error);
          this.busy = false;
          db.collection("log").add({
            time: new Date(),
            logType: "error",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + " " + platform.version,
            pillarrrVersion: this.$store.state.version,
            action: "Error updating User: " + this.activeCompName,
            extra: JSON.stringify(error),
          });
        });
    },
  },
  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    userRoles() {
      let userRolesSuperadmin = [
        { name: "Superadmin", id: "superadmin" },
        { name: "Admin", id: "admin" },
        { name: "Manager", id: "manager" },
        { name: "Medewerker", id: "employee" },
      ];
      let userRoles = [
        { name: "Admin", id: "admin" },
        { name: "Manager", id: "manager" },
        { name: "Medewerker", id: "employee" },
      ];
      if (this.formType == "superadmin") {
        return userRolesSuperadmin;
      } else {
        return userRoles;
      }
    },
    companyNarrowcasting() {
      if (_.includes(this.companyPackages, "narrowcasting")) {
        return true;
      } else {
        return false;
      }
    },
    companyDossier() {
      if (_.includes(this.companyPackages, "dossier")) {
        return true;
      } else {
        return false;
      }
    },
    companyPackages() {
      if (this.userRole == "superadmin") {
        return this.activeCompData.packages;
      } else {
        return this.$store.state.companyPackages;
      }
    },
    companyType() {
      return this.$store.state.companyType;
    },
    companyJourney() {
      if (_.includes(this.companyPackages, "customerjourney")) {
        return true;
      } else {
        return false;
      }
    },
    companyBarometers() {
      if (_.includes(this.companyPackages, "barometers")) {
        return true;
      } else {
        return false;
      }
    },
    filteredCompanies() {
      if (this.searchCompanies && this.searchCompanies.length > 0) {
        return this.companies.filter((company) => {
          return company.name
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies;
      }
    },
    changed() {
      if (_.isEqual(this.userFormInfo, this.userFormInfoOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
